import { MenuList } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekMenuList = styled(MenuList)(({ theme }) => ({}));

export { PeekMenuList, PeekMenuList as default };
